import { createAction } from '@reduxjs/toolkit';
import { WORKSPACE_ACTIONS } from '../../app/constants/reduxActionConstant';

const loadWorkSpaceList = createAction(WORKSPACE_ACTIONS.LOAD_WORKSPACE_LIST);

export { loadWorkSpaceList };
